import React, { Component } from 'react'
import styled from 'styled-components'

class Scroll extends Component {
  scrollToBottom() {
    this.scrollAnchor.parentNode.scrollTop = this.scrollAnchor.offsetTop
  }

  render() {
    const { style, children } = this.props
    return (
      <Container style={style}>
        {children}
        <div ref={el => this.scrollAnchor = el}></div>
      </Container>
    )

  }
}

const Container = styled.div`
  overflow: auto;
  height: inherit;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar:vertical {
    width: 11px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 11px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }

`



export default Scroll



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Scroll/index.js